import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Device } from "components/Navbars/DeviceStatus";
import { AllStatus } from "./AllStatus";
import "./Status.css";
import { showToast } from "services/utils/Status";
import { setReloadApi } from "services/Redux/leaveManagement";
import "react-toastify/dist/ReactToastify.css";
import sessionHandling from "services/utils/notificationUtils";

const EssStatus = () => {
  const dispatch = useDispatch();
  const { domain, token, userDetails } = useSelector(
    (state) => state.tokenReducer
  );
  let reLoadApi = useSelector((state) => state.leaveReducer.reLoadApi);
  const date = new Date().toISOString().split("T")[0];
  const [deviceOffine, setDeviceOffline] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${domain}checkinfilter/?department_id=${userDetails.department_id}&date=${date}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          if (response.status === 202) {
            setDeviceOffline(true);
          } else {
            if (res?.user_status_details) {
              dispatch(setReloadApi(false));
            }
          }
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };

    fetchData();
  }, [token, date, domain, reLoadApi, dispatch, userDetails.department_id]);

  return (
    <>
      {deviceOffine ? (
        <Grid sx={{ paddingTop: 20 }}>
          <Device />
        </Grid>
      ) : (
        <div className="flex flex-col items-center justify-center">
          <AllStatus
            date={date}
            departmentid={userDetails.department_id}
            setDeviceOffline={setDeviceOffline}
          />
        </div>
      )}
    </>
  );
};

export default EssStatus;
